import * as bootstrap from 'bootstrap';

import './../scss/main.scss';
import $ from 'jquery/dist/jquery';
import 'jquery-ui-dist/jquery-ui.min.css';
import jqueryUi from 'jquery-ui-dist/jquery-ui.min';
 import 'jquery-ui-touch-punch-amd/jquery.ui.touch-punch.min';
import validate from 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/localization/messages_ru.min';
import 'readmore-js/readmore.min.js';
import  'morecontent-js/dist/jquery.morecontent.min';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Vue from 'vue/dist/vue';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'drift-zoom/dist/Drift.min';
import '@fortawesome/fontawesome-free/js/all.min'

if (!window.jQuery) {
    window.jQuery = $;
}
if (!window.$) {
    window.$ = $;
}
if (!window.Vue) {
    window.Vue = Vue;
}
if (!window.ClassicEditor) {
    window.ClassicEditor = ClassicEditor;
}
if (!window.Vue) {
    window.Drift = Drift;
}
// services
import './services/lang'

//components
import './components/modals';
import './components/catalog';
import './components/payments';
import './components/phone';
import './components/geo_cascade';
import './components/autocomplete';
import './components/form';
import './components/nyroModal';
import './components/imageUploader';
// import 'free-jqgrid'


docReady(function () {
    // img to svg start
    $('img.img-svg').each(function () {
        var $img = $(this);
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');
        $.get(imgURL, function (data) {
            var $svg = $(data).find('svg');
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }
            $svg = $svg.removeAttr('xmlns:a');
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }
            $img.replaceWith($svg);
        }, 'xml');
    });
    // img to svg end
    function headerStyle() {
        if($('#offer').length){
            if($(window).width() < 993) {
                if(!$('.header').hasClass('product_page')) {
                    $('.header').addClass('product_page');
                    $('.header > .container').append($('#offer .product_tabs'));
                }
            }else {
                $('.header').removeClass('product_page');
                $('#offer').prepend($('.header .product_tabs'));
            }
        }
    }
    headerStyle();
    $(window).on('resize', headerStyle);

    //view more good item
    $('.tile-dnk-container .product_spec_items_more').on('click', function () {
        var prev = $(this).prev('.product_spec_items.productItem');
        prev.toggleClass('active');
        if(prev.hasClass('active')){
            $(this).text(__('collapse'));
        } else {
            $(this).text(__('all_chars'));
        }

    });
    $('#productSpec').readmore({
        moreLink: '<a href="#" class="product_spec_items_more">'+__('all_chars')+'</a>',
        lessLink: '<a href="#" class="product_spec_items_more">'+__('collapse')+'</a>',
    });
    $('.main-page-description-text').moreContent({
        "shadow": true, // Добавляет в разметку блок с тенью
        "textClose": __("read_all"),
        "textOpen": __("collapse"),
        // Если нужно изменить разметку блока с тенью:
        // tpl: {
        // 	shadow: '<div class="mrc-shadow"></div>'
        // }
    });
    var button = $('#button-up');
    $(window).scroll (function () {
        if ($(this).scrollTop () > 300) {
            button.fadeIn();
        } else {
            button.fadeOut();
        }
    });
    button.on('click', function(){
        $('body, html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
});